import sdkProvider from "../utilities/sdk-provider";

export const isAuthenticated = async () => {
  const identity = await sdkProvider("identity");
  return await identity.customer.isAuthenticated();
};

export const promptLogin = async () => {
  const identity = await sdkProvider("identity");
  return await identity.login();
};

export const replaceJSX = function (string, find, replace) {
  return string
    ?.split(find)
    .flatMap((item) => [item, replace])
    .slice(0, -1);
};
